import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardAlertInfo } from "../alert/StandardAlertInfo"

const useStyles = makeStyles()(() => ({
    disclaimer: {
        "@media print": {
            display: "none",
        },
    },
}))

export function ContactInfoDisclaimer() {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="meeting-service-contact-info-disclaimer" attrs={{ title: true }}>
            <StandardAlertInfo
                title="Customer contact information. Handle it with care."
                className={classes.disclaimer}
            />
        </LocalizedStrict>
    )
}
